import type { SVGProps } from "react";

export const SvgInteractLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="29" height="42" viewBox="0 0 29 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.9041 14.9046C15.7092 14.2393 10.521 15.8698 6.60178 19.2465C8.02985 20.9125 9.85052 22.2716 11.997 23.1579C15.1282 24.4509 18.4443 24.5296 21.4464 23.6119C21.8611 20.6568 21.656 17.6961 20.9041 14.9046ZM8.53177 0.700347C7.88035 0.431357 7.22324 0.19827 6.56299 0C5.54736 1.19289 4.70438 2.57516 4.09225 4.12358C2.1429 9.05473 3.01338 14.4339 5.92695 18.3967C9.95099 14.9374 15.2358 13.2174 20.5632 13.765C18.6797 8.03181 14.4485 3.14356 8.53177 0.700347Z"
      fill="url(#paint0_radial_1_10)"
    />
    <path
      d="M20.8645 14.9001C21.6152 17.6892 21.8188 20.6462 21.4048 23.5985C21.4201 23.5938 21.4354 23.5884 21.4506 23.5837C21.8598 20.6381 21.6538 17.6871 20.9041 14.9046C20.8908 14.9029 20.8778 14.9018 20.8645 14.9001ZM25.5289 16.1348C24.3866 15.6631 23.2252 15.3177 22.0594 15.0894C22.7028 17.6973 22.8944 20.4367 22.5818 23.1803C25.1213 22.1515 27.3715 20.3865 29 18.0262C27.9318 17.2874 26.773 16.6485 25.5289 16.1348Z"
      fill="url(#paint1_linear_1_10)"
    />
    <path
      d="M20.9041 14.9046C12.7383 13.8586 4.58782 18.4833 1.35909 26.6507C-0.680868 31.811 -0.345764 37.3489 1.838 42C9.69761 41.5469 16.9808 36.5717 20.1253 28.6173C21.9188 24.0802 22.084 19.284 20.9041 14.9046Z"
      fill="url(#paint2_linear_1_10)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1_10"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-10.2348 -30.2355 -32.3878 14.1762 15.6289 29.5502)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6C96" />
        <stop offset="1" stopColor="#FF023D" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_1_10"
        x1="4.08741"
        y1="43.2083"
        x2="14.4708"
        y2="-1.75892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA600" />
        <stop offset="1" stopColor="#FF5900" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_10"
        x1="17.7612"
        y1="34.898"
        x2="12.1595"
        y2="5.6647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B5C9" />
        <stop offset="1" stopColor="#009FDA" />
      </linearGradient>
    </defs>
  </svg>
);
